import { useMarkingContext } from '../MarkingContext/MarkingContext'
import { exportToCSV, normalizeFileName } from '../../../../../../utils/file'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'

const ButtonDownload = () => {
  const { markingStudents, currentPeriodicalReport, previousPeriodicalReport } = useMarkingContext()
  const hasPrevious = !!currentPeriodicalReport?.previousPeriodicalReportId

  const handleDownload = () => {
    const rows = []

    markingStudents.forEach((student) => {
      student.marking?.forEach((marking) => {
        if (hasPrevious && Array.isArray(marking.previousLevels) && marking.previousLevels.length) {
          marking.previousLevels.forEach((prev) => {
            rows.push({
              studentCode: student.studentCode,
              studentName: student.studentName,
              yearLevel: student.yearLevel?.name || '',
              prevCode: prev.code || prev.assessmentAreaId || '',
              prevName: prev.name || '',
              prevLevel: prev.level ?? '',
              currCode: marking.assessmentAreaCode || '',
              currName: marking.assessmentAreaName || '',
              currLevel: marking.level ?? ''
            })
          })
        } else {
          rows.push({
            studentCode: student.studentCode,
            studentName: student.studentName,
            yearLevel: student.yearLevel?.name || '',
            prevCode: '',
            prevName: '',
            prevLevel: '',
            currCode: marking.assessmentAreaCode || '',
            currName: marking.assessmentAreaName || '',
            currLevel: marking.level ?? ''
          })
        }
      })
    })

    const prevReportName = previousPeriodicalReport?.name || 'Previous'
    const currReportName = currentPeriodicalReport?.name || 'Current'

    const headers = hasPrevious
      ? [
          { label: 'Student Code', key: 'studentCode' },
          { label: 'Student Name', key: 'studentName' },
          { label: 'Year Level', key: 'yearLevel' },
          { label: `Previous Assessment Code (${prevReportName})`, key: 'prevCode' },
          { label: 'Previous Assessment Name', key: 'prevName' },
          { label: 'Previous Level', key: 'prevLevel' },
          { label: `Assessment Code (${currReportName})`, key: 'currCode' },
          { label: 'Assessment Name', key: 'currName' },
          { label: 'Level', key: 'currLevel' }
        ]
      : [
          { label: 'Student Code', key: 'studentCode' },
          { label: 'Student Name', key: 'studentName' },
          { label: 'Year Level', key: 'yearLevel' },
          { label: 'Assessment Code', key: 'currCode' },
          { label: 'Assessment Name', key: 'currName' },
          { label: 'Level', key: 'currLevel' }
        ]

    const filename = normalizeFileName(`periodical-report-${currReportName}`)
    exportToCSV(rows, headers, filename)
  }

  return (
    <ButtonStartIcon
      size='small'
      onClick={handleDownload}
      startIcon={['fal', 'file-spreadsheet']}
      color='primary'
      variant='outlined'
    >
      Download
    </ButtonStartIcon>
  )
}

export default ButtonDownload
